module.exports = __webpack_public_path__ + "img/small-logo.3b37796f.svg";